import { useInfiniteQuery, UseInfiniteQueryOptions } from "@tanstack/react-query";
import { fetchProfiles } from "PFCore/services/profile";
import { Collection, Meta, Profile } from "PFTypes";

import { profilesKeys } from "./query_keys";

type SpecificMeta = {
  page: number;
  totalPages: number;
};

type Params = {
  page: number;
  per_page?: number;
};

export const useProfilesInfinite = (
  params: Params,
  options: Omit<
    UseInfiniteQueryOptions<Collection<Profile[], SpecificMeta>>,
    "queryKey" | "queryFn" | "initialData"
  > & {
    initialData?: () => undefined;
  } = {}
) =>
  useInfiniteQuery({
    queryKey: profilesKeys.all(params),
    queryFn: ({ pageParam }) =>
      fetchProfiles({ ...params, page: pageParam }) as unknown as Promise<
        Collection<Profile[], SpecificMeta>
      >,
    getNextPageParam: (lastPage) => {
      const { meta } = lastPage;
      if (meta.page < ((meta as Meta<SpecificMeta>).totalPages ?? 0)) {
        return meta.page + 1;
      }
    },
    ...options
  });
